import Link from 'gatsby-link';
import moment from 'moment';
import React from 'react';

import EventListing from '../components/event-listing.js';

export default ({ data, pathContext }) =>
  <div>
    <div className="breadcrumb">
      <Link to="/">
        Home
      </Link>
      <span> › </span>
      Programm
    </div>

    <div className="title">
      Alle Termine am {moment(pathContext.date).format('D.MM.YYYY')}
    </div>

    <EventListing events={data.allEventsYaml.edges.map(edge => edge.node)} />
  </div>
;

export const query = graphql`
  query Date($date: String!) {
    allEventsYaml(
      filter: { start_date: { eq: $date } }
      sort: { fields: [start_time], order: ASC }
    ) {
      edges {
        node {
          ...EventListingFields
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/date.js